import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.avaliacoes.length > 0
        ? _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c("app-title", {
                    attrs: { texto: "GESTORES SEM RESPONSABILIDADES" },
                  }),
                  _c(VDataTable, {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.avaliacoes,
                      "items-per-page": -1,
                      "hide-default-footer": "",
                      "hide-default-header": "",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }